<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.80139 20.0141L6.55669 20.0141C5.13751 20.0141 3.98654 18.8631 3.98654 17.4439L3.98654 6.54984C3.98654 5.13066 5.13751 3.9797 6.55669 3.9797L9.80139 3.9797C10.2388 3.9797 10.5941 3.62541 10.5941 3.18805C10.5941 2.75069 10.2388 2.39539 9.80139 2.39539C9.80139 2.39539 8.18905 2.39539 6.55669 2.39539C4.26178 2.39539 2.40223 4.25493 2.40223 6.54984C2.40223 9.67845 2.40223 14.3153 2.40223 17.4439C2.40223 19.7388 4.26178 21.5984 6.55669 21.5984L9.80139 21.5984C10.2388 21.5984 10.594 21.2441 10.594 20.8067C10.594 20.3694 10.2388 20.0141 9.80139 20.0141ZM21.5712 12.0654L21.5712 12.0644L21.5722 12.0634C21.5922 11.9964 21.6032 11.9263 21.6052 11.8533L21.6052 11.8503L21.6052 11.8493L21.6052 11.8483L21.6052 11.8473L21.6052 11.8443L21.6052 11.8413L21.6052 11.8393L21.6052 11.8342C21.6052 11.8332 21.6052 11.8312 21.6052 11.8292L21.6052 11.8273L21.6052 11.8252L21.6052 11.8242L21.6052 11.8212L21.6052 11.8202L21.6052 11.8192L21.6052 11.8162L21.6052 11.8152C21.6032 11.7422 21.5922 11.6721 21.5722 11.6051L21.5712 11.6041L21.5712 11.6031C21.5342 11.483 21.4691 11.3699 21.373 11.2738L16.3659 6.26661C16.0566 5.95735 15.5542 5.95735 15.2449 6.26661C14.9357 6.57587 14.9357 7.07829 15.2449 7.38655L18.9 11.0426L8.39922 11.0426C7.96186 11.0426 7.60656 11.3969 7.60656 11.8342C7.60656 12.2716 7.96186 12.6269 8.39922 12.6269L18.9 12.6269L15.2449 16.282C14.9357 16.5912 14.9357 17.0936 15.2449 17.4029C15.5542 17.7121 16.0566 17.7121 16.3659 17.4029L21.373 12.3947C21.4691 12.2996 21.5342 12.1865 21.5712 12.0654Z"
      fill="#CA000A"
    />
  </svg>
</template>

<script>
export default {
  name: 'DashboardLogout'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
